import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RouteType } from "../models/enum";
import { RoleService } from "../shared/services/role.service";
import { GoogleAuthService } from "./google-api.service";

@Injectable({
	providedIn: "root",
})
export class AdminService {
	constructor(
		private router: Router,
		private roleService: RoleService,
		private authService: GoogleAuthService,
	) {}

	async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		if (!navigator.onLine) {
			if (this.authService.hasValidOfflineSession() && this.roleService.isAdmin) {
				return true;
			}
			this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
			return false;
		}

		const authenticated = await this.authService.ensureSessionResolved();
		if (authenticated && this.roleService.isAdmin) {
			return true;
		}

		this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
		return false;
	}
}
